import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      eyebrow="Doctrine 02"
      title="Privacy Policy"
      updated="February 2026"
      testid="page-privacy"
    >
      <section>
        <p className="text-white/60 italic">
          Discretion is the currency of the Club. This policy explains what we collect, why we collect it,
          and the limits we place on ourselves when handling your data.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">1. What We Collect</h2>
        <p>When you interact with the Club, we collect:</p>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li><strong className="text-cyan-400">Identity data</strong> — full name, email, date of birth (implicit via ID check at entry), Instagram handle (optional).</li>
          <li><strong className="text-cyan-400">Application data</strong> — your occupation / creative identity provided on the Guest List Application.</li>
          <li><strong className="text-cyan-400">Payment data</strong> — processed by Stripe; we never see or store your full card number. We retain the last 4 digits, card brand, and payment status.</li>
          <li><strong className="text-cyan-400">Attendance data</strong> — which events you registered for, redeemed, or attended.</li>
          <li><strong className="text-cyan-400">Technical data</strong> — IP address, browser type, and basic session logs used for security and fraud prevention.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">2. Why We Collect It</h2>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li>To curate the guest list and maintain the exclusivity of the Club.</li>
          <li>To process memberships, ticket purchases, and issue digital entry passes.</li>
          <li>To verify identity at the door and prevent fraudulent access.</li>
          <li>To send event confirmations, membership updates, and influencer approvals.</li>
          <li>To comply with legal and tax obligations.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">3. Who We Share It With</h2>
        <p>
          We do not sell your data. We share limited information only with trusted service providers who
          help us run the Club:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li><strong>Stripe</strong> — payment processing (see stripe.com/privacy).</li>
          <li><strong>Resend</strong> — transactional email delivery.</li>
          <li><strong>MongoDB Atlas</strong> — encrypted database storage.</li>
          <li><strong>Venue staff</strong> — receive the guest list on the night of the event for door check only.</li>
        </ul>
        <p>
          We may disclose information if compelled by law, subpoena, or if necessary to protect the safety
          of members and staff.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">4. Cookies & Tracking</h2>
        <p>
          We use only essential cookies required to keep you logged in and secure the checkout session.
          We do not run third-party ad trackers or behavioural profiling on the site.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">5. Data Retention</h2>
        <p>
          Membership, ticket, and application records are retained for as long as your account is active
          plus 24 months for financial and legal compliance. Payment records are retained for 7 years as
          required by tax law. You may request deletion of your personal profile at any time (see Rights below).
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">6. Your Rights</h2>
        <p>Depending on your jurisdiction, you have the right to:</p>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li>Request a copy of the personal data we hold about you.</li>
          <li>Correct inaccurate data.</li>
          <li>Request deletion of your account and associated data (except records we are legally required to keep).</li>
          <li>Withdraw consent for marketing emails at any time.</li>
        </ul>
        <p>
          To exercise any of these rights, email{" "}
          <a href="mailto:secretsoulciety@secretsoulcietyclub.com" className="text-cyan-400 hover:text-white transition">
            secretsoulciety@secretsoulcietyclub.com
          </a>. We respond within 30 days.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">7. Security</h2>
        <p>
          All connections are encrypted with TLS. Passwords are hashed using industry-standard algorithms.
          Payment data is tokenized by Stripe and never touches our servers. No system is impenetrable, and
          we cannot guarantee absolute security — but we treat your data with the discretion the Club is
          built on.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">8. Children</h2>
        <p>
          The Club is strictly 19+. We do not knowingly collect data from anyone under 19. If we discover
          such data, we delete it immediately.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">9. Changes to This Policy</h2>
        <p>
          We may update this policy from time to time. Material changes will be announced on the site and
          via email to active members.
        </p>
      </section>
    </LegalLayout>
  );
}
